import { MicroFrontEnd } from 'properties-ui-common'
import apiConfig from '../../../apiConfig'

export const IscCatalogs = () => {
  return (
    <MicroFrontEnd
      name="IscCatalogs"
      src={apiConfig.microFrontEnds.IscCatalogs}
      props={{ catalogMode: 'service' }}
    />
  )
}

export default IscCatalogs
